var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from "styled-components";
import { Paper, Grid } from "@material-ui/core";
import React from "react";
var Overlay = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9000;\n  background-color: rgba(127, 127, 127, 0.7);\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9000;\n  background-color: rgba(127, 127, 127, 0.7);\n"])));
var Background = styled(Paper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  overflow: hidden;\n  z-index: 9001;\n  width: 80%;\n  box-shadow: -2px 3px 2px 1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  margin: 3% 10% 3% 10%;\n  border-radius: 10px !important;\n"], ["\n  position: absolute;\n  overflow: hidden;\n  z-index: 9001;\n  width: 80%;\n  box-shadow: -2px 3px 2px 1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n  margin: 3% 10% 3% 10%;\n  border-radius: 10px !important;\n"])));
var CenterWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var OverlayBox = function OverlayBox(props) {
  return React.createElement(Overlay, null, React.createElement(Background, null, React.createElement(Grid, {
    container: true,
    direction: "row"
  }, props.children)));
};
var OverlayCenterWrapper = function OverlayCenterWrapper(props) {
  return React.createElement(Overlay, null, React.createElement(CenterWrapper, null, props.children));
};
export { OverlayBox, OverlayCenterWrapper };
var templateObject_1, templateObject_2, templateObject_3;